import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createBrowserRouter } from 'react-router-dom';
import {
  getUrlLocale,
  isLocaleAppliedByLoader,
  URL_LOCALE_PARAMS,
} from '~shared/lib/url-locale';

export const useUrlLocale = (
  router: ReturnType<typeof createBrowserRouter>,
) => {
  const {
    i18n: { language: currentLanguage, changeLanguage },
  } = useTranslation();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const locale = getUrlLocale(searchParams);

    if (!locale) return;

    // On redirecting entry routes the loader already applied the language and
    // its redirect drops the query string; navigating here would run it twice.
    if (!isLocaleAppliedByLoader(window.location.pathname, searchParams)) {
      URL_LOCALE_PARAMS.forEach(param => searchParams.delete(param));

      router.navigate({
        search: searchParams.toString(),
      });
    }

    if (locale !== currentLanguage) {
      changeLanguage(locale);
    }
  }, [changeLanguage, currentLanguage, router]);
};
